// extracted by mini-css-extract-plugin
export default {"ProfileBarWrap":"profile-header-bar_ProfileBarWrap__FRL0+"};